import { ThemeTokens } from './services/reservation-theme.service';

export interface ColorToken {
  key: string;
  label: string;
  group: string;
}

export interface TokenRow extends ColorToken {
  hex: string;
}

export interface TokenGroup {
  name: string;
  expanded: boolean;
  rows: TokenRow[];
}

export const COLOR_TOKENS: ColorToken[] = [
  {
    key: '--background',
    label: 'reservationTheme.colors.tokens.background',
    group: 'reservationTheme.colors.groups.basis'
  },
  {
    key: '--foreground',
    label: 'reservationTheme.colors.tokens.foreground',
    group: 'reservationTheme.colors.groups.basis'
  },
  {
    key: '--primary',
    label: 'reservationTheme.colors.tokens.primary',
    group: 'reservationTheme.colors.groups.akzente'
  },
  {
    key: '--primary-foreground',
    label: 'reservationTheme.colors.tokens.primaryForeground',
    group: 'reservationTheme.colors.groups.akzente'
  },
  {
    key: '--secondary',
    label: 'reservationTheme.colors.tokens.secondary',
    group: 'reservationTheme.colors.groups.akzente'
  },
  {
    key: '--secondary-foreground',
    label: 'reservationTheme.colors.tokens.secondaryForeground',
    group: 'reservationTheme.colors.groups.akzente'
  },
  { key: '--accent', label: 'reservationTheme.colors.tokens.accent', group: 'reservationTheme.colors.groups.akzente' },
  {
    key: '--accent-foreground',
    label: 'reservationTheme.colors.tokens.accentForeground',
    group: 'reservationTheme.colors.groups.akzente'
  },
  {
    key: '--muted',
    label: 'reservationTheme.colors.tokens.muted',
    group: 'reservationTheme.colors.groups.oberflaechen'
  },
  {
    key: '--muted-foreground',
    label: 'reservationTheme.colors.tokens.mutedForeground',
    group: 'reservationTheme.colors.groups.oberflaechen'
  },
  { key: '--card', label: 'reservationTheme.colors.tokens.card', group: 'reservationTheme.colors.groups.oberflaechen' },
  {
    key: '--card-foreground',
    label: 'reservationTheme.colors.tokens.cardForeground',
    group: 'reservationTheme.colors.groups.oberflaechen'
  },
  {
    key: '--popover',
    label: 'reservationTheme.colors.tokens.popover',
    group: 'reservationTheme.colors.groups.oberflaechen'
  },
  {
    key: '--popover-foreground',
    label: 'reservationTheme.colors.tokens.popoverForeground',
    group: 'reservationTheme.colors.groups.oberflaechen'
  },
  {
    key: '--border',
    label: 'reservationTheme.colors.tokens.border',
    group: 'reservationTheme.colors.groups.sonstiges'
  },
  { key: '--input', label: 'reservationTheme.colors.tokens.input', group: 'reservationTheme.colors.groups.sonstiges' },
  { key: '--ring', label: 'reservationTheme.colors.tokens.ring', group: 'reservationTheme.colors.groups.sonstiges' },
  {
    key: '--destructive',
    label: 'reservationTheme.colors.tokens.destructive',
    group: 'reservationTheme.colors.groups.sonstiges'
  },
  {
    key: '--destructive-foreground',
    label: 'reservationTheme.colors.tokens.destructiveForeground',
    group: 'reservationTheme.colors.groups.sonstiges'
  }
];

export const PRESETS: Record<string, ThemeTokens> = {
  Standard: {
    '--background': '0 0% 100%',
    '--foreground': '222 47% 11%',
    '--primary': '174 100% 29%',
    '--primary-foreground': '0 0% 100%',
    '--secondary': '210 40% 96%',
    '--secondary-foreground': '222 47% 11%',
    '--accent': '210 40% 96%',
    '--accent-foreground': '222 47% 11%',
    '--muted': '210 40% 96%',
    '--muted-foreground': '215 16% 47%',
    '--card': '0 0% 100%',
    '--card-foreground': '222 47% 11%',
    '--popover': '0 0% 100%',
    '--popover-foreground': '222 47% 11%',
    '--border': '214 32% 91%',
    '--input': '214 32% 91%',
    '--ring': '174 100% 29%',
    '--destructive': '0 84% 60%',
    '--destructive-foreground': '0 0% 100%'
  },
  Frisch: {
    '--background': '0 0% 100%',
    '--foreground': '222.2 84% 4.9%',
    '--card': '0 0% 100%',
    '--card-foreground': '222.2 84% 4.9%',
    '--popover': '0 0% 100%',
    '--popover-foreground': '222.2 84% 4.9%',
    '--primary': '222.2 47.4% 11.2%',
    '--primary-foreground': '210 40% 98%',
    '--secondary': '210 40% 96.1%',
    '--secondary-foreground': '222.2 47.4% 11.2%',
    '--muted': '210 40% 96.1%',
    '--muted-foreground': '215.4 16.3% 46.9%',
    '--accent': '210 40% 96.1%',
    '--accent-foreground': '222.2 47.4% 11.2%',
    '--destructive': '0 84.2% 60.2%',
    '--destructive-foreground': '210 40% 98%',
    '--border': '214.3 31.8% 91.4%',
    '--input': '214.3 31.8% 91.4%',
    '--ring': '222.2 84% 4.9%'
  },
  Waldgrün: {
    '--background': '120 20% 97%',
    '--foreground': '150 30% 10%',
    '--primary': '150 40% 25%',
    '--primary-foreground': '120 20% 97%',
    '--secondary': '140 20% 90%',
    '--secondary-foreground': '150 30% 15%',
    '--accent': '140 20% 90%',
    '--accent-foreground': '150 30% 15%',
    '--muted': '140 15% 92%',
    '--muted-foreground': '150 10% 45%',
    '--card': '120 20% 99%',
    '--card-foreground': '150 30% 10%',
    '--border': '140 15% 88%',
    '--input': '140 15% 88%',
    '--ring': '150 40% 25%'
  },
  'Warmes Gold': {
    '--background': '40 30% 97%',
    '--foreground': '30 50% 10%',
    '--primary': '35 70% 40%',
    '--primary-foreground': '30 50% 15%',
    '--secondary': '38 30% 90%',
    '--secondary-foreground': '30 50% 15%',
    '--accent': '38 30% 90%',
    '--accent-foreground': '30 50% 15%',
    '--muted': '38 20% 92%',
    '--muted-foreground': '30 15% 45%',
    '--card': '40 30% 99%',
    '--card-foreground': '30 50% 10%',
    '--border': '38 20% 88%',
    '--input': '38 20% 88%',
    '--ring': '35 70% 40%'
  },
  Alpenblau: {
    '--background': '210 30% 97%',
    '--foreground': '220 50% 10%',
    '--primary': '215 60% 35%',
    '--primary-foreground': '210 30% 97%',
    '--secondary': '210 25% 90%',
    '--secondary-foreground': '220 50% 15%',
    '--accent': '210 25% 90%',
    '--accent-foreground': '220 50% 15%',
    '--muted': '210 20% 92%',
    '--muted-foreground': '215 15% 45%',
    '--card': '210 30% 99%',
    '--card-foreground': '220 50% 10%',
    '--border': '210 20% 88%',
    '--input': '210 20% 88%',
    '--ring': '215 60% 35%'
  },
  Dunkel: {
    '--background': '220 20% 8%',
    '--foreground': '210 30% 92%',
    '--primary': '220 50% 55%',
    '--primary-foreground': '210 30% 97%',
    '--secondary': '220 15% 18%',
    '--secondary-foreground': '210 30% 90%',
    '--accent': '220 15% 18%',
    '--accent-foreground': '210 30% 90%',
    '--muted': '220 15% 15%',
    '--muted-foreground': '215 15% 55%',
    '--card': '220 20% 12%',
    '--card-foreground': '210 30% 92%',
    '--popover': '220 20% 12%',
    '--popover-foreground': '210 30% 92%',
    '--border': '220 15% 20%',
    '--input': '220 15% 20%',
    '--ring': '220 50% 55%'
  }
};

export const DEFAULT_PRIMARY_HEX = '#009688';
export const DEFAULT_PRIMARY_FONT = 'Nunito Sans';
export const DEFAULT_SECONDARY_FONT = 'Nunito Sans';

export const DEFAULT_HSL_VALUES: ThemeTokens = {
  '--background': '0 0% 100%',
  '--foreground': '222 47% 11%',
  '--primary': '174 100% 29%',
  '--primary-foreground': '0 0% 100%',
  '--secondary': '210 40% 96%',
  '--secondary-foreground': '222 47% 11%',
  '--accent': '210 40% 96%',
  '--accent-foreground': '222 47% 11%',
  '--muted': '210 40% 96%',
  '--muted-foreground': '215 16% 47%',
  '--card': '0 0% 100%',
  '--card-foreground': '222 47% 11%',
  '--popover': '0 0% 100%',
  '--popover-foreground': '222 47% 11%',
  '--border': '214 32% 91%',
  '--input': '214 32% 91%',
  '--ring': '174 100% 29%',
  '--destructive': '0 84% 60%',
  '--destructive-foreground': '0 0% 100%',
  '--font-primary': DEFAULT_PRIMARY_FONT,
  '--font-secondary': DEFAULT_SECONDARY_FONT
};

export const WIDGET_SCRIPT_URL = 'https://alpha.reservation.gastro.digital/widget/reservation-widget.iife.js';
export const WIDGET_ASSET_BASE = 'https://alpha.reservation.gastro.digital';

export const GROUP_ORDER = [
  'reservationTheme.colors.groups.basis',
  'reservationTheme.colors.groups.akzente',
  'reservationTheme.colors.groups.oberflaechen',
  'reservationTheme.colors.groups.sonstiges'
];
export const DEFAULT_EXPANDED = new Set(GROUP_ORDER);
